<div class="row">
  <div class="col-12">
    <div class="row">
      <div class="col-6 col-lg-2">
        <magieno-input-text-field
        [advancedFormControl]="this.childForm.formElements.firstName | asAdvancedFormControl"></magieno-input-text-field>
      </div>
      <div class="col-6 col-lg-2">
        <magieno-input-text-field
        [advancedFormControl]="this.childForm.formElements.lastName | asAdvancedFormControl"></magieno-input-text-field>
      </div>
    </div>

    <magieno-datepicker
    [advancedFormControl]="this.childForm.formElements.birthdate | asAdvancedFormControl">
      <i class="fas fa-calendar" calendarIcon></i>
    </magieno-datepicker>

    <magieno-input-money-field [locale]="this.locale"
      [currency]="this.currency"
    [advancedFormControl]="this.childForm.formElements.netIncome | asAdvancedFormControl"></magieno-input-money-field>

    <magieno-boolean-select
    [advancedFormControl]="this.childForm.formElements.isDisabled | asAdvancedFormControl"></magieno-boolean-select>
  </div>
</div>

@if (incomeTaxPersonalForm.value.isCareExpensesCalculated === true) {
  <div class="row mt-5">
    <div class="col-12">
      <h3 id="informations-sur-frais-de-garde">Informations sur les frais de garde</h3>
      <magieno-input-money-field [locale]="this.locale"
        [currency]="this.currency"
      [advancedFormControl]="federalForm.formElements.careExpensesOthers | asAdvancedFormControl"></magieno-input-money-field>
      <magieno-input-money-field [locale]="this.locale"
        [currency]="this.currency"
      [advancedFormControl]="quebecForm.formElements.careExpensesOthers | asAdvancedFormControl"></magieno-input-money-field>
      <app-rrsp-personal-tax-child-camps-form [form]="form"
      [camps]="camps"></app-rrsp-personal-tax-child-camps-form>
    </div>
  </div>
  } <!-- / .row -->




